import styled from 'styled-components/native';

export const Container = styled.View`
  padding-top: 8px;
  flex: 1;
`;
